/*
HTTP headers are case-insensitive. This can cause problems with trying to
directly use a JS object to map them.

For example: `x-UA-keymaster-digest` is equivalent to `X-UA-Keymaster-Digest`
for HTTP's purposes, but a JS object will treat those two variants as
different keys & possibly cause an erroneous miss.

We standardize the headers by lowercasing all the header keys across the board.
*/
module.exports = normalizeHeaders

function normalizeHeaders(headers) {
  const normalized = new Map()

  if (headers.forEach) {
    headers.forEach((value, key) => {
      normalized.set(key.toLowerCase(), value)
    })
  } else if (headers.entries) {
    for (let [key, value] of headers.entries()) {
      normalized.set(key.toLowerCase(), value)
    }
  } else {
    return keysToLower(headers)
  }

  return mapToObj(normalized)
}

function keysToLower(headers) {
  return Object.keys(headers).reduce((h, key) => {
    h[key.toLowerCase()] = headers[key]

    return h
  }, {})
}

function mapToObj(map) {
  const obj = {}

  map.forEach((value, key) => {
    obj[key] = value
  })

  return obj
}
